import { CaseContext } from '@/context/CaseContext';
import { useContext } from 'react';

const useCases = () => {
  return useContext(CaseContext);
};
export default useCases;
